import React from 'react'
import styled from 'styled-components'
import { graphql } from 'gatsby'
import { Trans, withTranslation } from 'react-i18next'

import Layout from '../components/layout'
import SEO from '../components/seo'
import Container from '../components/container'
import Image from '../components/image'

export const query = graphql`
  query {
    umbrellas: file(relativePath: { eq: "umbrellas.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000, maxHeight: 750) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`

export default styled(withTranslation()(({ className, t, data }) =>
  <Layout className={className}>
    <SEO
      lang={t('nsl.lang')}
      title={t('nsl.title')}
      description={t('nsl.description')} />

    <Container className='container'>
      <h1>{t('nsl.title')}</h1>

      <p className='image'>
        <Image fluid={data.umbrellas.childImageSharp.fluid} />
      </p>

      <Trans i18nKey='nsl.body' />

      <h2>{t('nsl.signatories')}</h2>
      <Trans i18nKey='nsl.signatoriesList' />
    </Container>
  </Layout>
))`
  .image {
    max-width: 1000px;
  }
`
